import { type ComponentPropsWithRef, type ForwardedRef, forwardRef, memo } from 'react';

import { Flex } from '@/components/base';
import Tooltip from '@/components/Tooltip/TooltipV2';

import S from './styled';
import type { IconButtonT } from './types';

const IconButton = memo(
  forwardRef(
    (
      props: IconButtonT & ComponentPropsWithRef<'button'>,
      ref: ForwardedRef<HTMLButtonElement | null>,
    ) => {
      const {
        icon,
        disabled = false,
        outlined = true,
        sizeType = 's',
        rounded = false,
        onClick,
        allowPropagation = false,
        css,
        tooltip,
        shortcut,
        ...rest
      } = props;

      return (
        <S.BtnWrapper
          {...rest}
          css={css}
          size={sizeType}
          outlined={outlined}
          disabled={disabled}
          rounded={rounded}
          onClick={(e) => {
            if (!allowPropagation) {
              e.stopPropagation();
            }
            onClick?.(e);
          }}
          ref={ref}
        >
          <Tooltip tooltipNode={tooltip} shortcut={shortcut}>
            <Flex a="center" j="center" className="h-full w-full">
              {icon}
            </Flex>
          </Tooltip>
        </S.BtnWrapper>
      );
    },
  ),
);

export default IconButton;
